import React from "react";
import { useLoaderData } from "react-router";
import TwoColumnLayout from "layout/TwoColumnLayout";
import InvoiceCopyEditSection from "invoice/copy/InvoiceCopyEditSection";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";

export const CopyInvoiceApp = () => {
  const viewModel = useLoaderData<server.viewmodel.InvoiceV1CopyFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <SectionPanel.Section>
        <InvoiceCopyEditSection viewModel={viewModel} />
      </SectionPanel.Section>
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[{ text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl }]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>;
};

export default CopyInvoiceApp;

